import Translate from "../Translate";

const Loading = () => {
    return <div><Translate i18nKey="common.loading"/>...</div>
};

export default Loading;
